
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/info/terms-and-conditions",
      function () {
        return require("private-next-pages/info/terms-and-conditions/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/info/terms-and-conditions"])
      });
    }
  